import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // ===== Flow / Stepper / Upload =====
      completeProfileStep: "Profile",
      flowStepDocuments: "Documents",
      flowStepReports: "Reports",
      flowStepInsurance: "Insurance",
      flowStepCategory: "Category",
      flowStepShort1: "1",
      flowStepShort2: "2",
      flowStepShort3: "3",
      flowStepShort4: "4",
      uploadDocuments: "Prescription upload",
      insuranceDocuments: "Insurance",
      adminApproval: "Admin Approval",
      categories: "Specialization",
      bid: "Bid",
      insuranceUploadTitle: "Medical insurance papers",
      insuranceUploadSubtitle:
        "Upload your policy card, coverage letter, or other insurance documents (optional)",
      uploadTitle: "Prescriptions & reports",
      rxOnlyTitle: "Prescription upload",
      rxOnlyDesc: "PDF or photos · max 20 MB each · large files are optimized automatically",
      rxStepHint: "Step 1 of 3: upload prescription photos or PDFs. Next you will add lab and imaging reports.",
      chooseDocumentType: "Type",
      uploadKindPrescriptionHint: "Prescriptions, medicine lists, doctor notes",
      uploadKindReportHint: "Lab results, imaging reports, discharge summaries",
      tapToChooseFiles: "Tap to browse",
      medicalReports: "",
      uploadDesc1: "PDF or images · max 20 MB per file",
      uploadDesc2: "",
      reportsUploadTitle: "Medical reports",
      reportsUploadDesc: "Labs, imaging, discharge summaries — PDF or photos (max 20 MB each)",
      rxSavedContinueReports: "Prescriptions saved. Add your reports below, then continue to insurance.",
      optimizingFiles: "Optimizing files…",
      upload: "Upload",
      redirectingToReports: "Opening medical reports…",
      nextInsurance: "Continue to insurance",
      continueToReports: "Continue to reports",
      continueToReportsBlockedHint:
        "Upload or remove the new files above before continuing to reports.",
      skipReportsNoFiles: "Skip — I have no reports to upload",
      skipInsuranceNoFiles: "Skip — I have no insurance documents to upload",
      nextSpecialization: "Continue to specialization",
      privateSecure: "Private & Secure",
      shareVerified: "Share only with verified hospitals",
      betterEvaluation: "Better Evaluation",
      helpsDoctors: "Helps doctors understand your conditions",
      fasterResponse: "Faster Response",
      reducesQuestions: "Reduces follow-up questions",
      uploadPhotos: "Upload Photos",
      dropFile: "Drop your file here",
      fileType: "JPG, PNG, PDF (Max 5MB)",
      addNote: "Add a note for Hospitals (optional)",
      addNoteShort: "Note (optional)",
      notePlaceholder: "Mention symptoms, duration, or any concerns...",
      notePlaceholderShort: "Optional context for hospitals…",
      back: "Back",
      next: "Next",
      submit: "Submit",
      dropImageHere: "Drop your image here or browse",
      supportFormat: "Support: PNG, JPG, JPEG, WEBP",
      fileSize: "Size",
      uploading: "Uploading...",
      uploadComplete: "Upload Complete",

      // ===== Consent =====
      consent: {
        title: "Patient Consent & Privacy Agreement",
        heading: "Your privacy and care journey matter to us.",
        sub: "Please read the following carefully before continuing.",

        sec1: {
          title: "1. Your Information",
          p1: "When you upload your prescription, reports, or enter your personal details on HealBid, we collect basic information such as:",
          li1: "Your name and contact details",
          li2: "Your uploaded prescriptions and medical reports",
          li3: "Treatment-related information you choose to share",
          p2: "This information is used only to help you receive treatment offers, book appointments, and coordinate your care."
        },

        sec2: {
          title: "2. How We Protect Your Data",
          p1: "Your information is:",
          li1: "Stored securely in our system",
          li2: "Protected with safety measures",
          li3: "Accessible only to authorized HealBid team members and relevant doctors/hospitals involved in your case",
          p2: "We do not sell, rent, or share your data outside HealBid. Your medical information stays within our platform unless required by law."
        },

        sec3: {
          title: "3. Limited Sharing for Your Treatment",
          p1: "To help you receive proper medical care, your details may be shared with:",
          li1: "Verified doctors",
          li2: "Associated hospitals",
          li3: "Medical representatives involved in your selected treatment",
          p2: "This sharing is strictly for coordinating your care."
        },

        sec4: {
          title: "4. When HealBid Is Responsible",
          p1: "HealBid supports you throughout your treatment journey only when the entire process is handled through our platform.",
          p2: "This means:",
          li1: "You book the appointment through HealBid",
          li2: "Communication continues through HealBid",
          li3: "The final treatment agreement is completed through HealBid",
          p3: "If you choose to continue directly with a doctor or hospital outside the platform, HealBid will not be responsible for that arrangement."
        },

        sec5: {
          title: "5. Our Role",
          p1: "(You can add any extra legal/role text here later if needed.)"
        }
      }
    }
  },

  hi: {
    translation: {
      // ===== Flow / Stepper / Upload =====
      completeProfileStep: "प्रोफ़ाइल",
      flowStepDocuments: "दस्तावेज़",
      flowStepReports: "रिपोर्ट",
      flowStepInsurance: "बीमा",
      flowStepCategory: "श्रेणी",
      flowStepShort1: "1",
      flowStepShort2: "2",
      flowStepShort3: "3",
      flowStepShort4: "4",
      uploadDocuments: "प्रिस्क्रिप्शन अपलोड",
      rxOnlyTitle: "प्रिस्क्रिप्शन अपलोड",
      insuranceDocuments: "बीमा",
      adminApproval: "एडमिन अनुमोदन",
      categories: "श्रेणियाँ",
      bid: "बिड",
      insuranceUploadTitle: "चिकित्सा बीमा कागज़ात",
      insuranceUploadSubtitle:
        "पॉलिसी कार्ड, कवरेज पत्र या अन्य बीमा दस्तावेज़ अपलोड करें (वैकल्पिक)",
      uploadTitle: "प्रिस्क्रिप्शन अपलोड करें",
      medicalReports: "मेडिकल रिपोर्ट",
      uploadDesc1: "अपने मेडिकल दस्तावेज़ अपलोड करें ताकि अस्पताल आपके केस की समीक्षा कर सकें",
      uploadDesc2: "और बेहतर इलाज विकल्प दे सकें",
      privateSecure: "प्राइवेट और सुरक्षित",
      shareVerified: "केवल सत्यापित अस्पतालों के साथ साझा करें",
      betterEvaluation: "बेहतर मूल्यांकन",
      helpsDoctors: "डॉक्टरों को आपकी स्थिति समझने में मदद",
      fasterResponse: "तेज़ प्रतिक्रिया",
      reducesQuestions: "फॉलो-अप सवाल कम करता है",
      uploadPhotos: "फोटो अपलोड करें",
      dropFile: "अपनी फ़ाइल यहाँ डालें",
      fileType: "JPG, PNG, PDF (Max 5MB)",
      addNote: "अस्पताल के लिए नोट जोड़ें (optional)",
      addNoteShort: "नोट (वैकल्पिक)",
      notePlaceholder: "लक्षण, समय या चिंता लिखें...",
      notePlaceholderShort: "अस्पताल के लिए संक्षिप्त संदेश…",
      back: "पीछे",
      next: "आगे",
      submit: "सबमिट",
      dropImageHere: "अपनी इमेज यहाँ ड्रॉप करें या ब्राउज़ करें",
      supportFormat: "सपोर्ट: PNG, JPG, JPEG, WEBP",
      fileSize: "साइज",
      uploading: "अपलोड हो रहा है...",
      uploadComplete: "अपलोड पूरा हुआ",
      continueToReports: "रिपोर्ट पर जारी रखें",
      continueToReportsBlockedHint:
        "रिपोर्ट पर जाने से पहले नई फ़ाइलें अपलोड करें या हटाएँ।",

      // ===== Consent =====
      consent: {
        title: "रोगी सहमति और गोपनीयता समझौता",
        heading: "आपकी गोपनीयता और उपचार यात्रा हमारे लिए महत्वपूर्ण है।",
        sub: "आगे बढ़ने से पहले कृपया नीचे दिए गए नियम ध्यान से पढ़ें।",

        sec1: {
          title: "1. आपकी जानकारी",
          p1: "जब आप HealBid पर अपना प्रिस्क्रिप्शन/रिपोर्ट अपलोड करते हैं या अपनी व्यक्तिगत जानकारी दर्ज करते हैं, तो हम निम्न जानकारी एकत्र कर सकते हैं:",
          li1: "आपका नाम और संपर्क विवरण",
          li2: "अपलोड किए गए प्रिस्क्रिप्शन और मेडिकल रिपोर्ट",
          li3: "इलाज से संबंधित वह जानकारी जो आप साझा करना चुनते हैं",
          p2: "यह जानकारी केवल उपचार ऑफ़र प्राप्त करने, अपॉइंटमेंट बुक करने और आपकी देखभाल समन्वय करने के लिए उपयोग की जाती है।"
        },

        sec2: {
          title: "2. हम आपके डेटा को कैसे सुरक्षित रखते हैं",
          p1: "आपकी जानकारी:",
          li1: "हमारे सिस्टम में सुरक्षित रूप से स्टोर की जाती है",
          li2: "सुरक्षा उपायों द्वारा संरक्षित रहती है",
          li3: "केवल अधिकृत HealBid टीम और आपके केस से जुड़े डॉक्टर/हॉस्पिटल ही इसे एक्सेस कर सकते हैं",
          p2: "हम आपका डेटा HealBid के बाहर बेचते, किराये पर देते या साझा नहीं करते। कानूनी आवश्यकता होने पर ही साझा किया जा सकता है।"
        },

        sec3: {
          title: "3. उपचार के लिए सीमित साझा करना",
          p1: "उचित चिकित्सा देखभाल में मदद के लिए, आपकी जानकारी साझा की जा सकती है:",
          li1: "सत्यापित डॉक्टरों के साथ",
          li2: "संबद्ध अस्पतालों के साथ",
          li3: "आपके चुने हुए उपचार से जुड़े मेडिकल प्रतिनिधियों के साथ",
          p2: "यह साझा करना केवल आपकी देखभाल के समन्वय के लिए किया जाता है।"
        },

        sec4: {
          title: "4. HealBid कब जिम्मेदार होगा",
          p1: "HealBid आपकी उपचार यात्रा में तभी सहायता और जिम्मेदारी निभाएगा जब पूरी प्रक्रिया हमारे प्लेटफ़ॉर्म के माध्यम से होगी।",
          p2: "इसका मतलब:",
          li1: "आप HealBid के माध्यम से अपॉइंटमेंट बुक करते हैं",
          li2: "संचार HealBid के माध्यम से जारी रहता है",
          li3: "अंतिम उपचार समझौता HealBid के माध्यम से पूरा होता है",
          p3: "यदि आप प्लेटफ़ॉर्म के बाहर सीधे किसी डॉक्टर/अस्पताल के साथ आगे बढ़ते हैं, तो उस व्यवस्था के लिए HealBid जिम्मेदार नहीं होगा।"
        },

        sec5: {
          title: "5. हमारी भूमिका",
          p1: "(ज़रूरत हो तो आप यहाँ आगे अतिरिक्त कानूनी/भूमिका संबंधित टेक्स्ट जोड़ सकते हैं।)"
        }
      }
    }
  },

  bn: {
    translation: {
      // ===== Flow / Stepper / Upload =====
      completeProfileStep: "প্রোফাইল",
      flowStepDocuments: "ডকুমেন্ট",
      flowStepReports: "রিপোর্ট",
      flowStepInsurance: "ইন্সুরেন্স",
      flowStepCategory: "ক্যাটাগরি",
      flowStepShort1: "1",
      flowStepShort2: "2",
      flowStepShort3: "3",
      flowStepShort4: "4",
      uploadDocuments: "প্রেসক্রিপশন আপলোড",
      rxOnlyTitle: "প্রেসক্রিপশন আপলোড",
      insuranceDocuments: "ইন্সুরেন্স",
      adminApproval: "অ্যাডমিন অনুমোদন",
      categories: "ক্যাটাগরি",
      bid: "বিড",
      insuranceUploadTitle: "মেডিকেল ইন্সুরেন্স কাগজপত্র",
      insuranceUploadSubtitle:
        "পলিসি কার্ড, কভারেজ লেটার বা অন্যান্য ইন্সুরেন্স ডকুমেন্ট আপলোড করুন (ঐচ্ছিক)",
      uploadTitle: "প্রেসক্রিপশন আপলোড",
      medicalReports: "মেডিকেল রিপোর্ট",
      uploadDesc1: "আপনার মেডিকেল ডকুমেন্ট আপলোড করুন",
      uploadDesc2: "যাতে হাসপাতাল আপনার কেস রিভিউ করতে পারে",
      privateSecure: "প্রাইভেট ও সিকিউর",
      shareVerified: "শুধু ভেরিফাইড হাসপাতালের সাথে শেয়ার",
      betterEvaluation: "ভালো ইভ্যালুয়েশন",
      helpsDoctors: "ডাক্তারদের বুঝতে সাহায্য করে",
      fasterResponse: "দ্রুত রেসপন্স",
      reducesQuestions: "কম ফলোআপ প্রশ্ন",
      uploadPhotos: "ছবি আপলোড করুন",
      dropFile: "এখানে ফাইল দিন",
      fileType: "JPG, PNG, PDF (Max 5MB)",
      addNote: "হাসপাতালের জন্য নোট (ঐচ্ছিক)",
      addNoteShort: "নোট (ঐচ্ছিক)",
      notePlaceholder: "লক্ষণ, সময় বা যে কোনো উদ্বেগ লিখুন...",
      notePlaceholderShort: "হাসপাতালের জন্য ছোট বার্তা…",
      back: "পেছনে",
      next: "পরবর্তী",
      submit: "সাবমিট",
      dropImageHere: "এখানে ছবি ড্রপ করুন বা ব্রাউজ করুন",
      supportFormat: "সাপোর্ট: PNG, JPG, JPEG, WEBP",
      fileSize: "সাইজ",
      uploading: "আপলোড হচ্ছে...",
      uploadComplete: "আপলোড সম্পন্ন",

      // ===== Consent =====
      consent: {
        title: "রোগীর সম্মতি ও গোপনীয়তা চুক্তি",
        heading: "আপনার গোপনীয়তা এবং চিকিৎসা যাত্রা আমাদের কাছে গুরুত্বপূর্ণ।",
        sub: "চালিয়ে যাওয়ার আগে অনুগ্রহ করে নিচের বিষয়গুলো মনোযোগ দিয়ে পড়ুন।",

        sec1: {
          title: "1. আপনার তথ্য",
          p1: "আপনি HealBid-এ প্রেসক্রিপশন/রিপোর্ট আপলোড করলে বা ব্যক্তিগত তথ্য দিলে আমরা নিচের মতো মৌলিক তথ্য সংগ্রহ করতে পারি:",
          li1: "আপনার নাম ও যোগাযোগের তথ্য",
          li2: "আপলোড করা প্রেসক্রিপশন ও মেডিকেল রিপোর্ট",
          li3: "চিকিৎসা সম্পর্কিত যে তথ্য আপনি শেয়ার করতে চান",
          p2: "এই তথ্য শুধুমাত্র চিকিৎসা অফার পাওয়া, অ্যাপয়েন্টমেন্ট বুক করা এবং আপনার কেয়ার সমন্বয় করার জন্য ব্যবহার করা হয়।"
        },

        sec2: {
          title: "2. আমরা কীভাবে আপনার ডেটা সুরক্ষিত রাখি",
          p1: "আপনার তথ্য:",
          li1: "আমাদের সিস্টেমে নিরাপদভাবে সংরক্ষণ করা হয়",
          li2: "বিভিন্ন সুরক্ষা ব্যবস্থার মাধ্যমে সুরক্ষিত থাকে",
          li3: "শুধুমাত্র অনুমোদিত HealBid টিম এবং আপনার কেসের সাথে সংশ্লিষ্ট ডাক্তার/হাসপাতাল অ্যাক্সেস করতে পারে",
          p2: "আমরা HealBid-এর বাইরে আপনার ডেটা বিক্রি, ভাড়া বা শেয়ার করি না। আইনগত কারণে প্রয়োজন হলে ব্যতিক্রম হতে পারে।"
        },

        sec3: {
          title: "3. আপনার চিকিৎসার জন্য সীমিত শেয়ারিং",
          p1: "সঠিক চিকিৎসা সেবা নিশ্চিত করতে আপনার তথ্য শেয়ার হতে পারে:",
          li1: "ভেরিফাইড ডাক্তারদের সাথে",
          li2: "সংশ্লিষ্ট হাসপাতালের সাথে",
          li3: "আপনার নির্বাচিত চিকিৎসার সাথে জড়িত মেডিকেল প্রতিনিধিদের সাথে",
          p2: "এই শেয়ারিং শুধুমাত্র আপনার কেয়ার সমন্বয়ের উদ্দেশ্যে করা হয়।"
        },

        sec4: {
          title: "4. কখন HealBid দায়ী থাকবে",
          p1: "HealBid শুধুমাত্র তখনই আপনার চিকিৎসা যাত্রায় সহায়তা ও দায়িত্ব বজায় রাখবে যখন পুরো প্রক্রিয়াটি আমাদের প্ল্যাটফর্মের মাধ্যমে সম্পন্ন হবে।",
          p2: "অর্থাৎ:",
          li1: "আপনি HealBid এর মাধ্যমে অ্যাপয়েন্টমেন্ট বুক করবেন",
          li2: "যোগাযোগ HealBid এর মাধ্যমেই চলবে",
          li3: "চূড়ান্ত চিকিৎসা চুক্তি HealBid এর মাধ্যমে সম্পন্ন হবে",
          p3: "আপনি যদি প্ল্যাটফর্মের বাইরে সরাসরি কোনো ডাক্তার/হাসপাতালের সাথে এগিয়ে যান, তাহলে সেই ব্যবস্থার জন্য HealBid দায়ী থাকবে না।"
        },

        sec5: {
          title: "5. আমাদের ভূমিকা",
          p1: "(প্রয়োজনে পরে এখানে অতিরিক্ত আইনগত/ভূমিকা সম্পর্কিত লেখা যোগ করতে পারবেন।)"
        }
      }
    }
  }
};

// ✅ save language
const savedLang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

export default i18n;
